export default defineNuxtRouteMiddleware(async (to, from) => {
  // Allow auth callbacks to proceed without interference
  if (to.path.startsWith('/auth/callback')) {
    console.log('Auth callback detected, skipping default route middleware')
    return
  }
  
  // Keep the landing page accessible without authentication
  // No redirects for the root path
  
  // Special case: If we're being redirected from root to login, intercept and stay on root
  // But only if there's no redirect parameter (which indicates a deliberate navigation)
  if (from.path === '/' && to.path === '/login' && !to.query.redirect) {
    return navigateTo('/', { replace: true })
  }
  
  // If redirecting from root to login with a redirect parameter, allow it to proceed
  if (from.path === '/' && to.path === '/login' && to.query.redirect) {
    return
  }
  
  if (to.path === '/') {
    // Check auth state when accessing root path
    const { isAuthenticated, checkSession } = useAuth()
    const { session } = await checkSession() 
    
    // If user is authenticated and trying to access home page, redirect to dashboard
    if (session && from.path.startsWith('/auth/')) {
      console.log('Authenticated user from auth flow redirected to dashboard')
      return navigateTo('/dashboard', { replace: true })
    }
  }
  
  return
}) 